import {useState} from 'react';
import {COLORS,SHAPES,LENGTHS,FINISHES,DECORATIONS,FINGERS,PATTERNS,normalizeDesign} from './design-model.js';
import NailArtwork from './NailArtwork.jsx';
import './design-summary.css';

const lookup=(items,id)=>items.find(item=>item.id===id);
const label=(items,id)=>lookup(items,id)?.name || id;
export const sizeLabel=d=>d.size==='custom'?(d.sizeMode==='per-finger'?'定制尺码':d.sizeMode==='tip-number'?'甲片号定制':'毫米定制'):d.size+' 码';
export const fingerSize=(d,i)=>d.size==='custom'?(d.sizeMode==='per-finger'?(d.fingerSizes?.[i]||'待选尺码'):d.sizeMode==='tip-number'?(d.tipNumbers?.[i]!=null?d.tipNumbers[i]+' 号':'待选号码'):(d.widths?.[i]!=null?d.widths[i]+' mm':'待测量')):d.size+' 码';
export const shapeLabel=d=>label(SHAPES,d.shape)+(d.shape?.startsWith('ns-')?'':' '+d.shapeVariant);
const materialLabel=id=>{const item=lookup(COLORS,id);return item?(item.code&&item.code!==item.name?item.name+' · '+item.code:item.name):id;};
function layerLabel(layer){
  if(layer.kind==='charm'){
    const material=lookup(DECORATIONS,layer.type),confirmed=material?.availableSizesMm?.includes(layer.sizeMm);
    return label(DECORATIONS,layer.type)+(confirmed?' · '+layer.sizeMm+' mm':' · 实物规格待确认');
  }
  if(layer.kind==='stroke')return layer.brush==='fill'?'手绘填色':'手绘线条';
  if(layer.kind==='sticker')return '自定义贴纸';
  return '图案 · '+label(PATTERNS,layer.type);
}
function materialDetails(nail){
  const effects=nail.opacity===0&&nail.finish==='glossy'?[]:[label(FINISHES,nail.finish)];
  if(nail.catEye.enabled&&nail.finish!=='cat-eye')effects.push('磁吸猫眼');
  if(nail.french.enabled&&nail.finish!=='french')effects.push('法式微笑');
  if(nail.gradient.enabled)effects.push('渐变：'+(nail.gradient.materialId?materialLabel(nail.gradient.materialId):nail.gradient.color));
  return effects.join(' · ') || '无附加工艺';
}
export default function DesignSummary({design,summary='查看十指设计与尺寸'}){
  const [open,setOpen]=useState(false);
  const d=normalizeDesign(design);
  return <details className="design-summary" onToggle={event=>setOpen(event.currentTarget.open)}>
    <summary>{summary}</summary>
    {open&&<div className="design-summary-content">
      <p className="design-summary-spec">{shapeLabel(d)} · {label(LENGTHS,d.length)} · {sizeLabel(d)}</p>
      {[0,1].map(hand=><section className="design-summary-hand" key={hand} aria-label={hand?'右手设计明细':'左手设计明细'}><h4>{hand?'右手':'左手'}</h4>
        {d.nails.slice(hand*5,hand*5+5).map((nail,index)=>{const finger=hand*5+index,visible=nail.layers.filter(layer=>layer.visible),hidden=nail.layers.length-visible.length;return <div className="design-summary-finger" key={finger} data-finger-index={finger}>
          <NailArtwork nail={nail} shape={d.shape} shapeVariant={d.shapeVariant} length={d.length} assets={d.assets} aria-hidden="true"/>
          <div><strong>{FINGERS[index]} · {fingerSize(d,finger)}</strong><p>底胶：{nail.opacity===0?'未选择':materialLabel(nail.color)}{nail.opacity>0&&nail.customColor?' · 自选色 '+nail.customColor:''}</p><p>{materialDetails(nail)}</p><p>装饰与图层：{visible.length?visible.map(layerLabel).join(' / '):'无'}{hidden?'（另有 '+hidden+' 个隐藏图层，不参与预览）':''}</p></div>
        </div>;})}
      </section>)}
      <p className="design-summary-note">显示这份购物袋或订单中保存的设计版本。屏幕颜色与实物可能存在差异。</p>
    </div>}
  </details>;
}
